import * as constants from './Exercise.constants';
import * as services from './Exercise.service';
import { answer } from './Exercise.service';

import { storeFactory } from '@/scripts/Exercise/Exercise.store';

export default storeFactory(constants, services, answer);
